<template>
  <v-container fluid>
    <v-card :loading="eventsLoad" class="ma-3">
      <v-card-title>
        <h1>Agenda</h1>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col :cols="dynamicCol" v-if="unidadesList.length > 0">
            <v-autocomplete
              v-model="IdUnidadeSelecionado"
              :items="unidadesList"
              item-text="Unidade"
              item-value="IdUnidade"
              label="Unidade"
              @change="[getEvents($event)]"
              hide-details
              outlined
              dense
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col :cols="dynamicCol">
            <v-autocomplete
              v-model="IdEmpresa"
              :items="empresasList"
              item-text="RazaoSocial"
              item-value="IdEmpresa"
              label="Empresa"
              @change="[getEvents($event)]"
              hide-details
              outlined
              dense
              clearable
            >
            </v-autocomplete>
          </v-col>
          <v-col :cols="dynamicCol" v-if="credenciadosList.length > 0">
            <v-autocomplete
              v-model="IdCredenciado"
              :items="credenciadosList"
              item-text="Nome"
              item-value="IdProfissional"
              label="Credenciado"
              @change="[getEvents($event)]"
              hide-details
              outlined
              dense
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col :cols="dynamicCol">
            <v-select
              v-model="IdEtiqueta"
              :items="etiquetas"
              item-text="titulo"
              item-value="IdEtiqueta"
              label="Tipo"
              @change="[getEvents($event)]"
              hide-details
              outlined
              dense
              clearable
            ></v-select>
          </v-col>
          <v-col :cols="dynamicCol">
            <v-select
              v-model="calendar.type"
              :items="calendar.typeOptions"
              label="Visualização"
              hide-details
              outlined
              dense
            ></v-select>
          </v-col>
          <v-col
            v-if="
              IdCredenciado != null ||
              IdEmpresa != null ||
              IdEtiqueta != null ||
              IdUnidadeSelecionado != null
            "
          >
            <v-btn
              color="primary"
              block
              v-bind:id="(dynamicCol = dynamicColCredenciado)"
              @click="[(dynamicCol = 2.4), limparFiltros()]"
              dark
            >
              Limpar Filtros
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn
              block
              large
              color="primary"
              @click="[getMenuNomes(), (modalPeriodoRelatorioMensal = true)]"
              dark
            >
              <v-icon left>mdi-file-document</v-icon>
              Gerar Relatório
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-col cols="6" sm="6" md="6" xs="12" lg="8" xl="9" class="pt-8">
                <v-btn
                  icon
                  small
                  dark
                  color="primary"
                  @click="$refs.calendar.prev()"
                  ><v-icon>mdi-chevron-left</v-icon></v-btn
                >
                <strong class="ml-2 mr-2" v-if="$refs.calendar">{{
                  $refs.calendar.title
                }}</strong>
                <v-btn
                  icon
                  small
                  dark
                  color="primary"
                  @click="$refs.calendar.next()"
                  ><v-icon>mdi-chevron-right</v-icon></v-btn
                >
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-sheet height="800px">
              <v-calendar
                v-model="atualDay"
                :type="calendar.type"
                ref="calendar"
                :now="today"
                :events="events"
                :event-color="getEventColor"
                color="primary"
                @click:more="showMore($event)"
                @click:event="showEvent($event)"
              >
                <template v-slot:event="{ event }">
                  <span style="font-weight: bold; padding-left: 4px">
                    {{ $moment(event.start).format("HH:mm") }}
                  </span>
                  {{ event.name }}
                </template>
              </v-calendar>
            </v-sheet>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog
      width="550"
      v-model="modalPeriodoRelatorioMensal"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <v-card-title>Gerar Relatório </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col :cols="$vuetify.breakpoint.xsOnly ? '12' : '6'">
              <v-menu
                v-model="menuDataInicial"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dataInicialRelatorio"
                    label="Data Inicial"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    type="date"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dataInicialRelatorio"
                  @input="menuDataInicial = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.xsOnly ? '12' : '6'">
              <v-menu
                v-model="menuDataFinal"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dataFinalRelatorio"
                    label="Data Final"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    type="date"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  :min="dataInicialRelatorio"
                  v-model="dataFinalRelatorio"
                  @input="menuDataFinal = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="loadRelatorio"
            @click="[(loader = 'loading'), gerarRelatorio()]"
            dark
          >
            Gerar Relatório
          </v-btn>
          <v-btn
            color="red"
            :loading="loadRelatorio"
            @click="[(modalPeriodoRelatorioMensal = false)]"
            dark
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Mais agendamentos -->
    <v-dialog
      width="50%"
      v-model="diagMore"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <v-card-title>
          Mais agendamentos - {{ dayMore }}
          <v-spacer></v-spacer>
          <v-btn icon @click="diagMore = !diagMore">
            <v-icon>mdi-close-box</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-chip
            v-for="item in eventsMore"
            :key="item.index"
            :color="item.color"
            label
            class="mb-1 col-12"
            @click="
              [
                (diagMore = false),
                (dayMore = null),
                showEventByDay(item.IdAgendamento),
              ]
            "
          >
            <span class="white--text subtitle-2">
              <strong>{{ $moment(item.start).format("HH:mm:ss") }}</strong>
              {{ item.name }}
            </span>
          </v-chip>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Detalhes do evento -->
    <v-dialog
      scrollable
      width="80%"
      v-model="diagDetalhesEvento"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card :loading="loadDetalhesEvento">
        <v-toolbar flat>
          <v-toolbar-title>
            <h3>Detalhes do Agendamento</h3>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="diagDetalhesEvento = !diagDetalhesEvento">
            <v-icon>mdi-close-box</v-icon>
          </v-btn>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text v-if="!loadDetalhesEvento" class="pt-2">
          <v-text-field
            label="Título"
            :value="eventoInfo.titulo"
            readonly
          ></v-text-field>
          <v-row>
            <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 9">
              <v-text-field
                :value="eventoInfo.RazaoSocial"
                label="Empresa"
                readonly
              ></v-text-field>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 3">
              <v-text-field
                :value="eventoInfo.CNPJ"
                label="CNPJ"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="9">
              <v-text-field
                :value="eventoInfo.Logradouro"
                label="Logradouro"
                readonly
              ></v-text-field>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.xsOnly ? 3 : 1">
              <v-text-field
                :value="eventoInfo.Numero"
                label="Número"
                readonly
              ></v-text-field>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.xsOnly ? 6 : 2">
              <v-text-field
                :value="eventoInfo.Cidade"
                label="Cidade"
                readonly
              ></v-text-field>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.xsOnly ? 6 : 9">
              <v-text-field
                :value="eventoInfo.Complemento"
                label="Complemento"
                readonly
              ></v-text-field>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 3">
              <v-text-field
                :value="eventoInfo.CEP"
                label="CEP"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 4">
              <v-text-field
                prepend-icon="mdi-clock"
                label="Data de saída do SESI"
                :value="$moment(eventoInfo.dataSaida).format('LLLL')"
                readonly
              ></v-text-field>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 4">
              <v-text-field
                prepend-icon="mdi-clock"
                label="Previsão de chegada à empresa"
                :value="$moment(eventoInfo.dataInicial).format('LLLL')"
                readonly
              ></v-text-field>
            </v-col>
            <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 4">
              <v-text-field
                prepend-icon="mdi-clock"
                label="Previsão de saída da empresa"
                :value="$moment(eventoInfo.dataFinal).format('LLLL')"
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <v-textarea
            label="Observações gerais"
            auto-grow
            :value="eventoInfo.descricao"
            outlined
            readonly
          ></v-textarea>
          <v-textarea
            label="Observações de uso interno"
            auto-grow
            :value="eventoInfo.obs_interna"
            outlined
            readonly
          ></v-textarea>
          <v-container>
            <h2 class="ma-4">Profissionais escalados:</h2>
            <v-chip
              class="blue ma-1"
              dark
              v-for="Profissional in Profissional"
              :key="Profissional.index"
            >
              <v-avatar left>
                <v-icon>mdi-account-circle</v-icon>
              </v-avatar>
              {{ Profissional.Nome }}
            </v-chip>
          </v-container>
          <v-container>
            <h2 class="ma-4">Procedimentos agendados:</h2>
            <v-chip
              class="green ma-1"
              dark
              v-for="credenciado in servicosInfo"
              :key="credenciado.index"
            >
              {{
                credenciado.Procedimento + ` (${credenciado.quantidadePessoas})`
              }}
            </v-chip>
          </v-container>
          <v-container v-if="tecnicosAgendados.length > 0">
            <h2 class="ma-4">Técnicos que acompanharão:</h2>
            <v-chip
              class="orange ma-1"
              dark
              v-for="tecnico in tecnicosAgendados"
              :key="tecnico.index"
            >
              {{ tecnico.Nome }}
            </v-chip>
          </v-container>
          <v-container v-if="termosList.length > 0">
            <h2 class="ma-4">Termos de acatamento:</h2>
            <v-chip
              class="grey ma-1"
              dark
              v-for="acatamentos in termosList"
              :key="acatamentos.index"
            >
              {{ acatamentos.NumeroContrato }}
            </v-chip>
          </v-container>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// @ is an alias to /src
export default {
  name: "Home",
  data: () => ({
    calendar: {
      type: "month",
      typeOptions: [
        { text: "Dia", value: "day" },
        { text: "4 Dias", value: "4day" },
        { text: "Semana", value: "week" },
        { text: "Mês", value: "month" },
      ],
    },
    // Evento
    diagEvento: false,
    // Detalhes evento
    eventoInfo: [],
    dynamicCol: 2.4,
    dynamicColCredenciado: 2.4,
    servicosInfo: [],
    termosList: [],
    dataInicialRelatorio: "",
    dataFinalRelatorio: "",
    menuDataInicial: false,
    menuDataFinal: false,
    menuEmpresa: false,
    EmpresaMenu: null,
    CredenciadoMenu: null,
    EtiquetaMenu: null,
    IdUnidadeSelecionado: null,
    UnidadeMenuSelecionado: null,
    menuUnidade: false,
    loadRelatorio: false,
    modalPeriodoRelatorioMensal: false,
    diagDetalhesEvento: false,
    loadDetalhesEvento: false,
    today: "2020-09-16",
    events: [],
    eventsLoad: false,
    empresasList: [],
    unidadesList: [],
    tecnicosAgendados: [],
    IdEmpresa: null,
    IdEtiqueta: null,
    IdCredenciado: null,
    credenciadosList: [],
    etiquetas: [],
    Profissional: [],
    atualDay: "2020-09-16",
    eventsMore: null,
    diagMore: false,
    loadDiagMore: false,
    dayMore: null,
  }),
  methods: {
    getEventColor(event) {
      if (event.color) {
        return event.color;
      } else {
        return "#9c27b0";
      }
    },
    getEmpresas() {
      this.axios("empresas/calendario").then((res) => {
        this.empresasList = res.data;
      });
    },
    getCredenciados() {
      this.axios("credenciados/calendario").then((res) => {
        if (res.data.length != 0) {
          this.credenciadosList = res.data;
        } else {
          this.dynamicCol = 3;
        }
      });
    },
    limparFiltros() {
      this.IdUnidadeSelecionado = null;
      this.IdCredenciado = null;
      this.IdEmpresa = null;
      this.IdEtiqueta = null;
      this.getEvents();
    },
    getTecnicos(idAgendamento) {
      this.axios
        .get(`agendamentos/${idAgendamento}/servicosTecnicos`)
        .then((res) => {
          this.tecnicosAgendados = res.data;
        });
    },
    getAcatamentos(IdAgendamento) {
      this.axios
        .get(`agendamentos/${IdAgendamento}/servicosTermos`)
        .then((res) => {
          this.termosList = res.data;
        });
    },
    showMore({ date }) {
      this.axios("agendamentos/calendario-dia", {
        params: {
          dia: date,
        },
      })
        .then((res) => {
          this.dayMore = this.$moment(date).format("L");
          this.eventsMore = res.data;
        })
        .finally(() => {
          this.diagMore = true;
        });
    },
    showEvent(event) {
      let IdAgendamento = event.event.IdAgendamento;
      this.diagDetalhesEvento = true;
      this.loadDetalhesEvento = true;
      this.axios(`agendamentos/${IdAgendamento}`)
        .then((res) => {
          this.eventoInfo = res.data[0];
        })
        .finally(() => {
          this.loadDetalhesEvento = false;
        });
      this.getServicosAgendados(IdAgendamento);
      this.getFuncionariosAgendados(IdAgendamento);
      this.getTecnicos(IdAgendamento);
      this.getAcatamentos(IdAgendamento);
    },
    showEventByDay(IdAgendamento) {
      this.diagDetalhesEvento = true;
      this.loadDetalhesEvento = true;
      this.axios(`agendamentos/${IdAgendamento}`, {
        params: {
          IdUnidade: this.IdUnidadeSelecionado,
          IdEmpresa: this.IdEmpresa,
          IdCredenciado: this.IdCredenciado,
          IdEtiqueta: this.IdEtiqueta,
        },
      })
        .then((res) => {
          this.eventoInfo = res.data[0];
        })
        .finally(() => {
          this.loadDetalhesEvento = false;
        });
      this.getServicosAgendados(IdAgendamento);
      this.getFuncionariosAgendados(IdAgendamento);
      this.getTecnicos(IdAgendamento);
      this.getAcatamentos(IdAgendamento);
    },
    getFuncionariosAgendados(IdAgendamento) {
      this.axios(`agendamentos/${IdAgendamento}/servicosProfissional`).then(
        (res) => {
          this.Profissional = res.data.map((funcionario) => {
            return {
              Nome: funcionario.Nome,
            };
          });
        }
      );
    },
    getUnidades() {
      this.axios("unidades").then((res) => {
        this.unidadesList = res.data;
        this.unidadeSelecionada = this.unidadesList[0].IdUnidade;
        this.getIdUnidade(this.unidadesList[0].IdUnidade);
      });
    },
    getServicosAgendados(IdAgendamento) {
      this.axios(`agendamentos/${IdAgendamento}/servicosAgenda`).then((res) => {
        this.servicosInfo = res.data;
      });
    },
    getMenuNomes() {
      var Unidades = this.unidadesList.length;
      var Empresas = this.empresasList.length;
      var Credenciados = this.credenciadosList.length;
      var Etiqueta = this.etiquetas.length;
      for (var uni = 0; uni < Unidades; uni++) {
        if (this.unidadesList[uni].IdUnidade == this.IdUnidadeSelecionado) {
          this.UnidadeMenuSelecionado = this.unidadesList[uni].Unidade;
        }
      }
      for (var emp = 0; emp < Empresas; emp++) {
        if (this.empresasList[emp].IdEmpresa == this.IdEmpresa) {
          this.EmpresaMenu = this.empresasList[emp].RazaoSocial;
        }
      }
      for (var cre = 0; cre < Credenciados; cre++) {
        if (this.credenciadosList[cre].IdProfissional == this.IdCredenciado) {
          this.CredenciadoMenu = this.credenciadosList[cre].Nome;
        }
      }
      for (var eti = 0; eti < Etiqueta; eti++) {
        if (this.etiquetas[eti].IdEtiqueta == this.IdEtiqueta) {
          this.EtiquetaMenu = this.etiquetas[eti].titulo;
        }
      }
    },
    getEvents() {
      this.eventsLoad = true;
      this.axios("agendamentos/calendario", {
        params: {
          IdUnidade: this.IdUnidadeSelecionado,
          IdEmpresa: this.IdEmpresa,
          IdCredenciado: this.IdCredenciado,
          IdEtiqueta: this.IdEtiqueta,
        },
      })
        .then((res) => {
          this.events = res.data;
        })
        .finally(() => {
          this.eventsLoad = false;
        });
    },
    getEtiquetas() {
      this.axios("etiquetas").then((res) => {
        this.etiquetas = res.data;
      });
    },
    newEtiqueta() {
      this.etiquetas.push({
        name: this.etiquetaTitle,
        color: this.etiquetaColor.hexa,
        isDark: this.etiquetaColorText,
      });
    },
    LimparCampos() {
      this.IdEmpresaMenu = null;
      this.IdUnidadeMenuSelecionado = null;
    },
    gerarRelatorio() {
      this.loadRelatorio = true;
      this.axios(`agendamentos/relatorio`, {
        params: {
          de: this.dataInicialRelatorio,
          ate: this.dataFinalRelatorio,
          IdUnidade: this.IdUnidadeSelecionado,
          IdEmpresa: this.IdEmpresa,
          IdCredenciado: this.IdCredenciado,
          IdEtiqueta: this.IdEtiqueta,
        },
        responseType: "arraybuffer",
      })
        .then((res) => {
          var blob = new Blob([res.data], {
            type: "application/pdf",
          });
          var url = window.URL.createObjectURL(blob);
          window.open(url);
        })
        .finally(() => {
          this.loadRelatorio = false;
          this.modalPeriodoRelatorioMensal = false;
        });
    },
  },
  mounted() {
    this.today = this.$moment().format("YYYY-MM-DD");
    this.atualDay = this.$moment().format("YYYY-MM-DD");
    this.getEvents();
    this.getEtiquetas();
    this.getEmpresas();
    this.getCredenciados();
    this.getUnidades();
  },
};
</script>